import PropTypes from 'prop-types'

export default PropTypes.shape({
  interopKey: PropTypes.string,
  number: PropTypes.string,
  postalCode: PropTypes.string,
  street: PropTypes.string,
  townName: PropTypes.string
})
